import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import React, { useEffect } from 'react';

import { useActiveBrand } from '@/brand';
import { useHotelCurrencyValue } from '@/currency-preview';
import { getEnvironmentKey } from '@/env/client/config';
import { useLocale } from '@/i18n';
import { useTheme } from '@/ui/theme';

import { getDisloyaltyBaseUrl, transformToDisloyaltyBrandKey } from '../utils';

interface MembershipBenefitsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

// get "CLOSE_TELEPORT_MODAL" boolean from the iframe "back to booking" button and call onClose
const useMessageEventListener = (onClose: () => void) => {
  useEffect(() => {
    const handleClose = (event: MessageEvent) => {
      if (event.data === 'CLOSE_TELEPORT_MODAL') {
        onClose();
      }
    };

    window.addEventListener('message', handleClose, false);
    return () => window.removeEventListener('message', handleClose);
  }, [onClose]);
};

export const MembershipBenefitsModal = ({
  isOpen,
  onClose,
}: MembershipBenefitsModalProps) => {
  useMessageEventListener(onClose);

  const hotelCurrency = useHotelCurrencyValue();

  const brandKey = useActiveBrand();

  const {
    componentProperties: { modals },
  } = useTheme();

  const { baseName: language } = useLocale();

  const env = getEnvironmentKey();

  const disloyaltyBenefitsUrl = `${getDisloyaltyBaseUrl(
    env
  )}/${language}/teleport/benefits/${transformToDisloyaltyBrandKey(
    brandKey
  )}/?currency=${hotelCurrency}`;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay
        css={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', ...modals?.overlay }}
      />
      <ModalContent
        maxWidth="900px"
        rounded="20px"
        overflow="hidden"
        border="1px solid #E8E5D8"
        bg="#143C21"
      >
        <iframe src={disloyaltyBenefitsUrl} width="100%" height="663px" />
      </ModalContent>
    </Modal>
  );
};
